/*
 *		Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Utils').factory('debounce', [
    function() {
        return function (func, delay) {
            var timer;
            return function(){
                clearTimeout(timer);
                var args = arguments;
                timer = setTimeout(function () {
                    func.apply(null, args);
                }, delay);
            };
        }
    }
]);
